import React from 'react';
import { Icon } from './Icon.js';
export const IconFeather = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m14.451,9.699c-.513,3.998-3.934,4.571-7.451,4.003", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" }),
        React.createElement("path", { d: "m3,17s1.469-12.904,14-14c-.627,1.093-.642,2.918-1.06,4.748-.587,2.252-2.615,2.532-5.1,2.532", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconFeather.js.map